module.exports = "https://cdn2-fs.clearscore.com/flux/images/daa335d9ba55a3483d4bd4aaf7cd1265.jpg";